import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import { View } from 'react-native';
import { FormattedMessage } from '@dbk/format';
import { ArrowRight } from '@dbk/ui-icons';
import Text, { Large } from '@dbk/ui-text';
import ModalSelector from '../modal-selector';
import { ALL_PORTFOLIO_ID, PALETTE , PORTFOLIO_RELIDTYPE, PORTFOLIO_BP_LIMIT} from '../../../constants';
import styles from './portfolio-selector.styles';
import labelForPFid from '../../../utils/portfolio-number-aria-label';

class PortfolioSelector extends PureComponent {
  constructor() {
    super();

    this.state = {
      modalVisible: false,
      searchText: '',
      filteredPortfolios: []
    };

    this.handleTriggerPress = this.handleTriggerPress.bind(this);
    this.handlePortfolioSelect = this.handlePortfolioSelect.bind(this);
    this.handleModalDone = this.handleModalDone.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  componentDidUpdate(){
    if(document.querySelector('.ModalHeader span')){ // for PF selection popup focus
      document.querySelector('.ModalHeader span').focus();
    }
  }
  handleTriggerPress() {
    this.setState({
      modalVisible: true,
    });
  }

  handlePortfolioSelect(portfolio) {
    const { messages, portfolioBPLimit } = this.props;
    this.setState({
      searchText: '',
    });

    // WMCE - 7679 To close modal on same selection
    if(portfolio.id !== this.props.selectedPortfolio.id || portfolio.relId !== this.props.selectedPortfolio.relId){
      this.props.onPortfolioSelect(portfolio);
    }
    this.handleModalDone();
  }

  handleModalDone() {
    this.setState({
      modalVisible: false,
      searchText: '',
    });
    this.forceUpdate();
  }

  componentDidUpdate(){
    if(document.querySelector('.ModalHeader span') && !this.state.searchText && !this.props.logoutVisible){ // for PF selection popup focus
      document.querySelector('.ModalHeader span').focus();
    }
  }

  renderOption(option, index) {

    const { modalVisible, filteredPortfolios } = this.state;

    const portfolio = this.state.searchText.length > 0 ? filteredPortfolios[index]: this.props.portfolios[index]; // WMCE- 7587 When only single portfolio present 

    const { portfolioRelId, pfLabel } = this.getPortfolioDisplay(portfolio, true);
    const selectedPortfolioDisplay = portfolioRelId + pfLabel;
    // const styling = isTrue ? {} : {color: PALETTE.primaryActive};
    const textSize = option.relIdType === PORTFOLIO_RELIDTYPE.PORTFOLIOS ? "normal" : "large";
    return (
      <View style={styles.option} accessibilityLabel={labelForPFid(portfolioRelId)+pfLabel}>
        <Text size={textSize} testID={`text_portfolio_${index}_portfolioSelector_test`}>{selectedPortfolioDisplay}</Text>
      </View>
    );
  }

  getPortfolioDisplay(portfolio, renderList) {
    let portfolioRelId = '';

    if (
      this.props.onRsaAuthorised === true ||
      this.props.onVascoAuthorised === true
    ) {
      portfolioRelId =
        portfolio.relId !== null ? portfolio.relId : portfolio.title;
    } else if (portfolio.relId === null) {
      portfolioRelId =
        portfolio.title.substr(0, 1) + 'XXXXX' + portfolio.title.slice(6);
    } else {
      portfolioRelId =
        portfolio.relId.substr(0, 1) + 'XXXXX' + portfolio.relId.slice(6);
    }
    if (portfolio.id === ALL_PORTFOLIO_ID)
      return ({ portfolioRelId:  this.props.messages["app.chedelivery.reports.allPortfolioTitle"], pfLabel: ''})
    if(portfolio.relIdType === PORTFOLIO_RELIDTYPE.ALL_PORTFOLIOS)
      return ({ portfolioRelId:  this.props.messages["app.dashboard.selector.allAccounts"], pfLabel: ''})

    if(portfolio.relIdType === PORTFOLIO_RELIDTYPE.PORTFOLIOS){
      let pfLabel= '';
      if(renderList){
        pfLabel =  ` - ${portfolio.referenceCurrency.toUpperCase()} (${portfolio.pfType} ${this.props.messages["app.dashboard.summaryData.portfolioId.label"]})`;
      }
      else {
        pfLabel = ` - ${portfolio.referenceCurrency.toUpperCase()}`;
      }
      return { portfolioRelId, pfLabel };
    }

    if(portfolio.relIdType === PORTFOLIO_RELIDTYPE.CONSOLIDATED){
      let pfLabel= '';
      if(renderList){
        portfolioRelId =  `${portfolioRelId} (${this.props.messages["app.header.wigdet.consolidated.label"]})`;
      }
      else {
        portfolioRelId = `${portfolioRelId}`;
      }
      return { portfolioRelId, pfLabel: '' };
    }
    return ({ portfolioRelId:  portfolio.relIdName ? portfolio.relIdName : portfolioRelId, pfLabel: `- ${portfolio.referenceCurrency.toUpperCase()}`})
  }

  handleSearchChange = (value) => {
    const {
      portfolios,
    } = this.props;

    var resultantArray = [];
    var searchValue = value.toLowerCase(); // WMCE-46257 - To allow space in search input
    portfolios.length > 0 && portfolios.map(item => {

      let portfolioRelId = (item.relIdName ? (`${item.relIdName}-${item.referenceCurrency}`).toLocaleLowerCase() : '') + 
         (`${item.relId !== null ? item.relId : item.title}-${item.referenceCurrency}`).toLocaleLowerCase();
      if (item.pfType) {
        portfolioRelId = portfolioRelId + `(${item.pfType.toLowerCase()} ${this.props.messages["app.dashboard.summaryData.portfolioId.label"].toLowerCase()})`;
      } else if (item.relIdType == PORTFOLIO_RELIDTYPE.CONSOLIDATED) {
        portfolioRelId = portfolioRelId + `${this.props.messages["app.header.wigdet.consolidated.label"].toLowerCase()}`;
      } else if (item.relIdType == PORTFOLIO_RELIDTYPE.ALL_PORTFOLIOS) {
        portfolioRelId = this.props.messages["app.dashboard.selector.allAccounts"].toLowerCase();
      }

      if (portfolioRelId.includes(searchValue)) {
        let existItem = resultantArray.some(obj => obj.id === item.id && obj.pfType === item.pfType && obj.referenceCurrency === item.referenceCurrency)
        if(!existItem)  //WMCE-47778-For avoiding the entry of duplicate items
        {
          resultantArray.push(item);
        }
        if(item.relIdType === PORTFOLIO_RELIDTYPE.BP && item.relIdName) {
          portfolios.map(selItem => {
            selItem.relIdType === PORTFOLIO_RELIDTYPE.PORTFOLIOS && selItem.title.includes(item.relId) && resultantArray.push(selItem);
          })
        }
      }
    });
    this.setState({
      filteredPortfolios: resultantArray,
      searchText: value
    })
  }

  render() {
    const {
      portfolios,
      selectedPortfolio,
      messages,
    } = this.props;

    const { modalVisible, filteredPortfolios } = this.state;

    const { portfolioRelId, pfLabel } = this.getPortfolioDisplay( selectedPortfolio);
    const selectedPortfolioDisplay = portfolioRelId + pfLabel;

    const portfolioLength = this.state.searchText.length > 0 ? filteredPortfolios.length: portfolios.length; // WMCE- 7587 When only single portfolio present 

    const portfoliosList = this.state.searchText.length > 0 ? filteredPortfolios : portfolios;
    return (
      <View style={styles.root}>
        <div id="portfolio-id" className="portfolio-data" aria-label={messages['app.reports.accountPortfolioDropdown']}>
        {portfolioLength > 1? 
          <TouchableOpacity
            style={styles.trigger}
            onPress={this.handleTriggerPress}
          >
              <div className="portfolio-name">
               <div className="elipsis-div">{portfolioRelId}</div> 
               <div className="selected-portfolio-curr">{pfLabel}</div> 
              </div>
            <ArrowRight className="close-icon" width={16} height={10} />        
          </TouchableOpacity>:

         <Text className="single-portfolio">
         {selectedPortfolioDisplay}
       </Text>}
        </div>
        <ModalSelector
          title={messages['app.header.wigdet.selection.title']}
          visible={modalVisible}
          options={portfoliosList}
          selectedOption={selectedPortfolio}
          renderOption={this.renderOption}
          onSelect={this.handlePortfolioSelect}
          onDone={this.handleModalDone}
          doneLabel={messages['app.common.closeText']}
          style={styles.root}
          searchText={this.state.searchText}
          handleSearchChange={this.handleSearchChange} 
          messages={messages}
        />
      </View>
    );
  }
}

PortfolioSelector.propTypes = {
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      referenceCurrency: PropTypes.string,
      relId: PropTypes.string,
      relIdType: PropTypes.string,
      pfType: PropTypes.string,
      branchCode: PropTypes.number,
      dayChange: PropTypes.shape({
        percent: PropTypes.number,
      }),
    })
  ).isRequired,
  selectedPortfolio: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    referenceCurrency: PropTypes.string,
    relId: PropTypes.string,
    relIdType: PropTypes.string,
    branchCode: PropTypes.number,
    pfType: PropTypes.string,
  }).isRequired,
  onPortfolioSelect: PropTypes.func.isRequired,
  onRsaAuthorised: PropTypes.bool,
  onVascoAuthorised: PropTypes.bool,
};

export default PortfolioSelector;
